"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var app_theme_defaule_1 = tslib_1.__importDefault(require("./app-theme-defaule"));
var appThemeLight = tslib_1.__assign(tslib_1.__assign({}, app_theme_defaule_1.default), { MuiMenu: {
        paper: {
            background: "rgb(255, 255, 255)",
        },
    }, DirectoryTitle: {
        color: "rgb(107, 116, 128)",
    }, settingWrap: {
        backgroundColor: "rgb(242, 243, 245)",
    }, settingDirectory: {
        backgroundColor: "rgb(242, 243, 245)",
    }, settingContent: {
        backgroundColor: "rgb(255, 255, 255)",
    }, Setting: {
        color: "rgb(185,187,190)",
        color2: "rgb(46, 51, 56)",
        color3: "rgb(6, 6, 7)",
        color4: "rgb(79,86,96)",
        color5: "rgb(115,128,140)",
        color6: "rgb(185,187,190)",
        color7: "rgb(114,128,125)",
        color8: "rgb(248,249,249)",
        color9: "rgb(227, 229, 232)",
        color10: "rgb(134, 143, 151)",
        color11: "rgb(235, 235, 236)",
        color12: "rgb(32,34,37)",
        color13: "rgb(252, 252, 252)",
        color14: "rgb(255, 255, 255)",
        color15: "rgb(0, 0, 0)",
        color16: "rgb(255, 255, 255)",
        color17: "rgb(242,243,245)",
        color18: "rgb(193,195,199)",
        color19: "rgb(137,137,137)",
    }, DirectoryViewWrap: {
        backgroundColor: "rgb(242, 224, 227)",
    }, SettingDirectory: {
        backgroundColor: "rgb(212, 215, 220)",
    }, SmallTitle: {
        color: "rgb(79, 86, 96)",
    }, DesTitle: {
        color: "rgb(107, 116, 128)",
    }, SettingUserInfoView: {
        borderColor: "rgb(227, 229, 232)",
        backgroundColor: "rgb(242, 243, 245)",
        UserInfoView_text: "rgb(135, 143, 152)",
        UserInfoView_name: "rgb(79, 84, 92)",
        UserInfoView_namecode: "rgb(164, 167, 171)",
    }, SettingRoundRadioButtonView: {
        radioIcon: "rgb(185, 187, 190)",
        language: "rgb(46, 51, 56)",
        country: "rgb(79, 86, 96)",
    }, SettingBoxRadioButtonGroupView: {
        borderColor: "rgb(227,229,232)",
        backgroundColor: "rgb(250, 250, 250)",
        radioBoxContentDesDefaultColor: "rgb(79,86,96)",
        radioBoxContentDesChoosedColor: "rgb(255,255,255)",
        radioIconDefaultColor: "rgb(185,187,190)",
        radioIconChoosedColor: "rgb(255,255,255)",
    }, DirectoryViewTextBlueColor: {
        backgroundColor: "rgb(228,232,242)",
    } });
exports.default = appThemeLight;
//# sourceMappingURL=app-theme-light.js.map